import image1 from '../assets/images/piamont.png';
import image2 from '../assets/images/Zentral.jpg';
import charityImage1 from '../assets/images/charity1.jpg';
import charityImage2 from '../assets/images/charity2.jpg';
import upcomingImage1 from '../assets/images/nani_boronat.jpeg';
import upcomingImage2 from '../assets/images/Gibraltar Wave FC.png';
import studyImage1 from '../assets/images/Libros.jpg';
import studyImage3 from '../assets/images/Obra.jpg';
import studyImage2 from '../assets/images/logoIwanit.jpg';
import { contractABI } from './contractConfig';
import { Project } from '../types/projectTypes';
import { ethers } from 'ethers';

export const fetchProjectsConfig = async (): Promise<{ 
  activeProjects: Project[], 
  upcomingProjects: Project[], 
  studyProjects: Project[] 
}> => {

  // Función para obtener el total supply desde el contrato del proyecto
  const fetchTokensIssued = async (contractAddress: string, contractABI: any) => {
    try {
      const provider = new ethers.providers.JsonRpcProvider("https://sepolia-rollup.arbitrum.io/rpc");
      const contract = new ethers.Contract(contractAddress, contractABI, provider);
      const totalSupply = await contract.totalSupply();
      return parseFloat(ethers.utils.formatUnits(totalSupply, 18));
    } catch (error) {
      console.error(`Error fetching total supply for contract ${contractAddress}:`, error);
      return 0;
    }
  };
  return {
    activeProjects: [],
    upcomingProjects: [
      {
        id: '1',
        title: 'Hotel 5 Estrellas Gran Lujo Piamont Residences (Sayulita, Puerto Vallarta, México)',
        promoter: 'BGA',
        image: image1,
        category: 'Real Estate',
        description: 'Plataforma de inversión inmobiliaria para financiar proyectos a través de inversores mintoristas con pasarelas de pago tanto fiat como cripto utilizando la tecnología blockchain. El proyecto no solo fue técnico sino que además incluia asesoría legal.',
        isActive: true,
        totalTokens: 642,
        tokensIssued: await fetchTokensIssued('0xFD08870348a6913154E75087a054d1fb439063e5', contractABI),
        contractAddress: '0xFD08870348a6913154E75087a054d1fb439063e5',
        contractABI: contractABI,
        isDonating: true,
        charityImage: charityImage1,
        donationPercentage: 1,
        tokenPrice: 1000,
        charityTitle: 'Donación para la Educación en Saluyita',
        charityDescription: 'Contribuye al futuro de los niños en Saluyita con tu inversión. Un porcentaje de los ingresos se destina a becas para educación.',
        projectUrl: 'https://bga.token-meet.com/sale/0xbdd154df41b21587531668935b0e5e1d5fb1bc3b',
        charityUrl: 'https://charity-saluyita.org/donacion-educacion'
      },
      {
        id: '2',
        title: 'Apartamentos de Lujo Zentral (Guadalajara - México)',
        promoter: 'BGA',
        image: image2,
        category: 'Real Estate',
        description: 'Plataforma de inversión inmobiliaria para financiar proyectos a través de inversores mintoristas con pasarelas de pago tanto fiat como cripto utilizando la tecnología blockchain. El proyecto no solo fue técnico sino que además incluia asesoría legal.',
        isActive: true,
        totalTokens: 292,
        tokensIssued: await fetchTokensIssued('0xB036Eed37e4a220F8c73E97C3CFd8ef31390477C', contractABI),
        contractAddress: '0xB036Eed37e4a220F8c73E97C3CFd8ef31390477C',
        contractABI: contractABI,
        isDonating: true,
        charityImage: charityImage2,
        donationPercentage: 1,
        tokenPrice: 1000,
        charityTitle: 'Apoyo a Refugios en Guadalajara',
        charityDescription: 'Una parte de tu inversión ayudará a mantener y mejorar los refugios para personas sin hogar en Guadalajara.',
        projectUrl: 'https://bga.token-meet.com/sale/0xdd9f709262fe09082735835e15721fae0bf9da7c',
        charityUrl: 'https://refugios-guadalajara.org/apoyo'
      },
      {
        id: '3',
        title: 'Colección NFTs Nani Boronat',
        promoter: 'Nani Boronat',
        image: upcomingImage1,
        category: 'Arte',
        description: 'Rediseño de marca, web con portafilio, historia, tienda virtual y tokenización de colección NFTs para sus seguidores más fieles.',
        isActive: false,
        totalTokens: 500,
        tokensIssued: 0,
        contractAddress: '0x123456789abcdef0123456789abcdef01234567',
        contractABI: contractABI,
        isDonating: false,
        tokenPrice: 800,
        projectUrl: 'https://www.naniboronat.com/'
      },
      
      
    ],
    studyProjects: [
      {
        id: '4',
        title: 'Gibraltar Wave FC',
        promoter: 'Gibraltar Wave FC',
        image: upcomingImage2,
        category: 'Deportes',
        description: 'Tokenización de parcelas de campo de futbol como representación de carnet de socios y fans',
        isActive: false,
        totalTokens: 500,
        tokensIssued: 0,
        contractAddress: '0x123456789abcdef0123456789abcdef01234567',
        contractABI: contractABI,
        isDonating: false,
        tokenPrice: 800,
        projectUrl: 'https://www.gibraltarwavefc.com/'
      },
      {
        id: '5',
        title: 'Publicación de Libros Tokenizados',
        promoter: 'Javier Gomez',
        image: studyImage1,
        category: 'Talentos',
        description: 'Plataforma de tokenización de libros para la venta de capítulos exclusivos y contenido detrás de escena como notas del autor y material inédito.',
        isActive: false,
        totalTokens: 500,
        tokensIssued: 0,
        contractAddress: '',
        contractABI: contractABI,
        isDonating: false,
        tokenPrice: 800,
        projectUrl: ''
      },
      {
        id: '6',
        title: 'Iwanit',
        promoter: 'Iwanit',
        image: studyImage2,
        category: 'Red Social',
        description: 'Creación de imagen de marca, inteligencia artificial, página web, aplicación nativa android e ios de la red social y backoffce para los administradores.',
        isActive: false,
        totalTokens: 500,
        tokensIssued: 0,
        contractAddress: '0x123456789abcdef0123456789abcdef01234567',
        contractABI: contractABI,
        isDonating: false,
        tokenPrice: 800,
        projectUrl: 'https://iwanit.io'
      },
      {
        id: '7',
        title: 'Comunidad para la Obtención de Matrículas Universitarias',
        promoter: 'Universidad de Cartagena',
        image: studyImage3,
        category: 'Cultura',
        description: 'Emisión de certificados académicos en blockchain, garantizando la autenticidad y permanencia de los títulos. Este enfoque eliminará fraudes y facilitará la validación global, permitiendo a los estudiantes recibir diplomas digitales que podrán ser verificados de manera instantánea por empleadores e instituciones en todo el mundo, sin necesidad de documentos físicos. Esta iniciativa fortalecerá la confianza en el sistema educativo y conectará a los estudiantes con oportunidades en el mercado laboral. Además, se desarrollará una plataforma a nivel de Colombia que tratará sobre la creación de una comunidad para la obtención de matrículas en las universidades.',
        isActive: false,
        totalTokens: 500,
        tokensIssued: 0,
        contractAddress: '0x123456789abcdef0123456789abcdef01234567',
        contractABI: contractABI,
        isDonating: false,
        tokenPrice: 800,
        projectUrl: ''
      },
    
    ]
  };
};
